const lang = {
    'hop-on': 'Hop On!',
    'decription-1': '<span class="text-wrap-sm">一鍵啟動，在城市兜兜風！</span>不管是日常通勤或假日出遊，<span class="text-wrap"><span class="text-wrap-sm">有了 GoShare 和 GoShare DOTS，</span>搜尋、租借、騎乘 Gogoro 電動機車，</span><span class="text-wrap">暢遊全台灣就是那麼簡單！</span>',
    'decription-2': '<span class="text-wrap-sm">不僅如此，</span>GoShare 更走向國際市場，<span class="text-wrap-ex-sm"><span class="text-wrap-sm">為叫車與外送</span>提供企業專屬車隊服務，</span><span class="text-wrap-sm">加速實現永續城市願景！</span>',
};

export default lang;
